// @flow

import invariant from 'invariant';
import Globalize from '../globalize';

export type Translation = {
  language: string,
  text: string,
};

export type TranslateDictionary = Array<Translation>;

export type TranslateDictionaryOptions = {
  language?: string,
  defaultValue?: string,
};

/**
 * Přeloži zadaný Resource String do přednastaveného jazyku, nebo vrati spravny preklad.
 *
 * @param resource ResoureId nebo prekladovy slovnik.
 * @param options Vlastnosti k resource, nebo nastaveni prekladove tabulky.
 */
export default function translate(
  resource: string | TranslateDictionary | Error,
  options?: Object | TranslateDictionaryOptions
): string {
  invariant(resource, '`path` is required for translation');

  if(typeof resource === 'string') {
    return Globalize.messageFormatter(resource)(options);
  }
  else {
    return 'not translated';
  }

  // let { language, defaultValue } = options || {};

  // language = language || Globalize.locale().attributes.language;
  // defaultValue = defaultValue || '';

  // let r = ((resource: any): TranslateDictionary).filter(i => i.language === language);

  // invariant(r.length <= 1, `Dictionary contains more than one translations for \`${language}\``);

  // return r.length === 0
  //   ? defaultValue
  //   : r[0].text;
};



// WEBPACK FOOTER //
// ./src/application/translate/translate.js